import { createApi } from 'swag-client-common/libs/rapi';
const baseUrl = '/api/v1/blog';
const postsAmount = 2;
const BlogApi = createApi({
  posts: {
    url: `${baseUrl}/posts?per_page=${postsAmount}`,
    method: 'get'
  }
});
export default BlogApi;